export default __webpack_public_path__ + "static/impact-background-819dd30004e72bf7cace11befb1ea599.png";